const USER_NOT_FOUND_MESSAGE = "This user is not found !";

const getLoginErrorMessage = (err, t) => {
    const apiMessage = err?.response?.data?.message;

    if (apiMessage) {
        if (apiMessage === USER_NOT_FOUND_MESSAGE) {
            return t("emailNotCorrect");
        }
        return apiMessage;
    }

    return t("unexpectedError");
};

export default getLoginErrorMessage;
